import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';

const containerBorder = css`
	position: relative;
	cursor: move;
	&::after {
		content: '';
		border: 1px dotted currentColor;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		pointer-events: none;
		display: block;
		z-index: 1;
		border-radius: inherit;
	}
`;

// those attributes are set in RenderNode
export default styled(Box)`
	.page-container {
		& div[data-editor-type='container'] {
			&[component-selected],
			&[component-drop-target],
			&[component-drag-on],
			&[component-drag-on] div[data-editor-type='container'],
			&:hover,
			&:hover div[data-editor-type='container'],
			&:hover *[component-hovered],
			&:hover *[component-drop-target],
			& *[component-selected] {
				${containerBorder}
			}
		}
	}

	// we need it to be more specific then the standard border
	&&&& .page-container {
		[component-selected] {
			&::after {
				border-width: 2px;
			}
		}
	}
	&&&& .page-container {
		*[component-drop-target] {
			&::after {
				border-width: 2px;
				border-style: dashed;
			}
		}
	}
`;
